import { render, staticRenderFns } from "./SubjectData.vue?vue&type=template&id=1cba186a&"
import script from "./SubjectData.vue?vue&type=script&lang=js&"
export * from "./SubjectData.vue?vue&type=script&lang=js&"
import style0 from "./SubjectData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports